import { Box, Button, Card } from "@mui/material";

const MembershipFormButtons = () => {
    return (

        <Card sx={{ width: '100%', mb: '1'}}>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                <a href={`${process.env.PUBLIC_URL}/documents/forms/New_Membership_2024_2025.docx`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{
                            margin: 1,
                            // bgcolor: 'deepskyblue', // background color
                            // '&:hover': {
                            //     bgcolor: 'skyblue', // background color when hovered
                            // }
                        }}
                    >
                        Download New Membership Application
                    </Button>
                </a>
                <a href={`${process.env.PUBLIC_URL}/documents/forms/Membership_Renewal_2024_2025.docx`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{
                            margin: 1,
                            bgcolor: 'deepskyblue', // background color
                            '&:hover': {
                                bgcolor: 'skyblue', // background color when hovered
                            }
                        }}
                    >
                        Download Membership Renewal Form
                    </Button>
                </a>
            </Box>
        </Card>
    );
}

export default MembershipFormButtons;